import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AuthorizationService from '../../../engage/service/AuthorizationService';
import { isLoggedIn } from '../../../engage/utils/auth-util';
import { useUserContext } from '../../../engage/context/UserContext';
import { useMessageContext } from '../../../engage/context/MessageContext';
import i18n from 'i18next';

const LogoutPage = () => {
  const history = useHistory();
  const { reset } = useUserContext();
  const { resetContext } = useMessageContext();

  useEffect(() => {
    const state = history.location.state;
    window.CRISP_TOKEN_ID = '';
    $crisp.push(['do', 'session:reset']);
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:close']);
    const handleLogout = async () => {
      try {
        const isUserLoggedIn = await isLoggedIn();
        if (isUserLoggedIn) {
          await AuthorizationService.logOut();
        }
      } catch (e) {
        console.log('error Logout ', e);
      } finally {
        reset();
        resetContext();
        window.Appcues?.reset();
        i18n.changeLanguage();
        history.push('/login', state);
      }
    };

    handleLogout();

    return () => {
      history.push('/login', state);
    };
  }, []);

  return <></>;
};

export default LogoutPage;
